// Canonical Oireachtas competition ordering — OUR OWN competition list's
// order (backend seed/ecro2026Template.js, transcribed from the owner's
// tracker/syllabus). The catalog array order can NOT carry this: competitions
// come back in insertion order and the template clone interleaves the groups,
// so every surface listing more than one competition sorts explicitly.
//
// Verified against the template: applying this comparator to its 105
// competitions reproduces the file's own sequence exactly (2026 code scheme:
// F-prefixed teams, X = Mixed, age-aware 18+ letters L/M).
//
// The order, derived from fields so it holds for any similarly-coded catalog:
//  1. Groups in syllabus sequence (list below).
//  2. Solo Championships: the mixed baby comps (U6/U7) first, then the FULL
//     girls/ladies ladder young->old, then the full boys/men ladder — the
//     syllabus lists gender BLOCKS, not G/B pairs per age. "ladies"/"men"
//     are the 18+ gender values and rank with their youth halves.
//  3. Adult Championship (SC-AC) before Advanced Adult (SC-AA).
//  4. Everything else reads straight down the codes: ages are zero-padded so
//     08 < 10 < 99 (& Over) < AC (Adult), and 4-/8-Hand interleave -G before
//     -X within each age the same way the syllabus does (senior 8-Hand:
//     -L before -X).

const GROUP_ORDER = [
  "Solo Championships",
  "Adult Championships",
  "Solo Championship Treble Reels",
  "Solo Championship Trad Sets",
  "Premiere",
  "Premiere Treble Reels",
  "2-Hand Teams",
  "3-Hand Teams",
  "4-Hand Teams",
  "6-Hand Teams",
  "8-Hand Teams",
  "Figure & Dance Drama",
];

const groupRank = (c) => {
  const i = GROUP_ORDER.indexOf(c && c.group);
  return i === -1 ? GROUP_ORDER.length : i;
};

export function compareComps(a, b) {
  const g = groupRank(a) - groupRank(b);
  if (g) return g;
  const group = a && a.group;
  if (group === "Solo Championships") {
    const gr = (c) =>
      ["girls", "ladies"].includes(c.gender) ? 1
        : ["boys", "men"].includes(c.gender) ? 2
          : 0;
    if (gr(a) !== gr(b)) return gr(a) - gr(b);
  }
  if (group === "Adult Championships") {
    const adv = (c) => (/AA$/.test(String(c.code || "")) ? 1 : 0);
    if (adv(a) !== adv(b)) return adv(a) - adv(b);
  }
  if (group === "Figure & Dance Drama") {
    // Figures first, Dance Drama closes the syllabus.
    const dd = (c) => (String(c.code || "") === "DD" ? 1 : 0);
    if (dd(a) !== dd(b)) return dd(a) - dd(b);
  }
  return String((a && a.code) || "").localeCompare(String((b && b.code) || ""));
}

export default compareComps;
